import styled from "styled-components";
import { Body, H2, H3 } from "../../styles/stringStyles";
import { readTextWithLineBreak } from "../../utils/handleTextWithLineBreak";
import { hexWithOpacity } from "../../utils/helpers";

type Props = {
  headline?: string;
  text?: string[];
  preHeadline?: string;
  ref?: React.Ref<HTMLDivElement>;
  className?: string;
  subtitles?: string[];
};

export const InfoText = ({
  preHeadline,
  headline,
  text,
  subtitles,
  ref,
  className,
}: Props) => {
  return (
    <ContainerWith10Gap ref={ref} className={className}>
      {preHeadline && <StyledH3>{preHeadline}</StyledH3>}
      <H2>{headline}</H2>
      {subtitles && (
        <div>
          {subtitles.map((text, index) => (
            <Subtitle key={index}>{text}</Subtitle>
          ))}
        </div>
      )}
      {text && (
        <ContainerWith30Gap>
          {text?.map((text, index) => (
            <Subtitle key={index}>{readTextWithLineBreak(text)}</Subtitle>
          ))}
        </ContainerWith30Gap>
      )}
    </ContainerWith10Gap>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

const ContainerWith10Gap = styled(Container)`
  gap: 10px;
  width: 100%;
  min-height: 48px;
  justify-content: center;
`;

const ContainerWith30Gap = styled(Container)`
  gap: 30px;
`;

const StyledH3 = styled(H3)`
  opacity: 0.6;
`;

const Subtitle = styled(Body)`
  color: ${({ theme }) => hexWithOpacity(theme.colors.dark, 0.5)};
`;
